import {autoSizeAllColumns} from "./helpers/autoSizeAllColumns";
import {selectActiveRowByDetail} from "./helpers/selectActiveRow";
import {onReady} from "./events/onReady";
import {hideK1Loader, showK1Loader} from "../global/helpers";
import {createFakeServer, createServerSideTreeDatasource} from "./serverSide";

export function loadDataFromUrl(url) {
	fetch(url).then(function (response) {
		return response.json();
	}).then(function (jsonData) {
		gridSettings.api.setRowData(jsonData.data);
		autoSizeAllColumns();
		onReady();

		selectActiveRowByDetail();
	})
}

export function loadNewDataFromUrl(url) {
	showK1Loader();

	fetch(url).then(function (response) {
		return response.json();
	}).then(function (jsonData) {
		gridSettings.api.setRowData(jsonData.data);
		autoSizeAllColumns();
		onReady();

		hideK1Loader();
	})
}

function fetchNewDataFromUrl(url) {
	if (typeof gridSettings.api.context.contextParams.providedBeanInstances.gridOptions.context.serverSideTree !== "undefined") {
		fetchNewTreeData(url);
		return;
	}

	if (gridSettings.api.context.contextParams.providedBeanInstances.gridOptions.rowModelType === "serverSide") {
		gridSettings.api.refreshServerSide({ route: [], purge: true });
		return;
	}

	loadNewDataFromUrl(url);
}

export function fetchTreeData(gridDataUrl) {
	fetch(gridDataUrl)
		.then((response) => response.json())
		.then(function (responseData) {
			var fakeServer = createFakeServer(responseData.data);
			var datasource = createServerSideTreeDatasource(fakeServer);
			gridSettings.api.setServerSideDatasource(datasource);

			autoSizeAllColumns();
			onReady();

			selectActiveRowByDetail();
			preOpenGroups();
		});
}

function preOpenGroups() {
	window.setTimeout(function () {
		for (let i in window.expandedGroupIds) {
			let path = window.expandedGroupIds[i].toString().split('.');
			for (let j in path) {
				openGroup(path[j]);
			}
		}
	}, 1000);
}

let triedOpenings = [];

function openGroup(rowId) {
	let rowNode = gridSettings.api.getRowNode(rowId.toString());
	if (typeof rowNode !== 'undefined') {
		rowNode.setExpanded(true);
		return;
	}

	if (triedOpenings[rowId] === true) {
		return;
	}

	window.setTimeout(function () {
		triedOpenings[rowId] = true;
		openGroup(rowId);
	}, 400);
}

export function fetchNewTreeData(gridDataUrl) {
	showK1Loader();

	fetch(gridDataUrl)
		.then((response) => response.json())
		.then(function (responseData) {
			hideK1Loader();

			var fakeServer = createFakeServer(responseData.data);
			var datasource = createServerSideTreeDatasource(fakeServer);
			gridSettings.api.setServerSideDatasource(datasource);

			autoSizeAllColumns();
			onReady();

			preOpenGroups();
		});
}


window.fetchTreeData = fetchTreeData
window.fetchNewDataFromUrl = fetchNewDataFromUrl
window.fetchNewTreeData = fetchNewTreeData
window.loadNewDataFromUrl = loadNewDataFromUrl
